// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HZgjQU {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: var(--bs-orange-500, #d64000);
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;
}

.HZgjQU:hover {
  color: var(--bs-orange-600, #b63600);
}

.u1gA0V {
  width: 16px;
  height: 16px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/LandingPageClient/components/NetworkLink.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".networkLink {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  color: var(--bs-orange-500, #d64000);\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.networkLink:hover {\n  color: var(--bs-orange-600, #b63600);\n}\n\n.networkLinkIcon {\n  width: 16px;\n  height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"networkLink": `HZgjQU`,
	"networkLinkIcon": `u1gA0V`
};
module.exports = ___CSS_LOADER_EXPORT___;
